// base  url
import { API } from "./apiConfig";

// create login api
export const login = (userData) => API.post("/Login", userData);
